import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import Router from './router'
import mitt from 'mitt'

const app = createApp(App)
// 全局注册emit
app.config.globalProperties.emit = new mitt()

app.use(Router)
app.use(ElementPlus)
app.mount('#app')
